import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-home-title',
  imports:[RouterModule],
  templateUrl: './home-title.component.html',
  styleUrl: './home-title.component.scss'
})
export class HomeTitleComponent {

}
